<script lang="ts" setup>
import { i18n } from '@/i18n';
import { computed, ref, watch } from 'vue';
import ForecastForReceiptSelectInput from '../../ForecastForReceiptSelectInput.vue';
import InfoModal from '@/corePagesModule/components/InfoModal.vue';
import { ForecastForReceiptFormState } from '@/customerForecastModule/domains/entities/ForecastForReceiptMenu';

const props = defineProps<{
  modalState: boolean;
  selectInputIndex: number;
}>();

const emits = defineEmits<{
  (e: 'close'): void;
  (e: 'apply', selectedForecastForReceiptId: string, selectedForecastForReceiptFormState?: ForecastForReceiptFormState): void;
}>();

//変数
const t = i18n.t;

const selectedForecastForReceiptId = ref<string>();
const selectedForecastForReceiptFormState = ref<ForecastForReceiptFormState>();

watch(
  () => props.modalState,
  (newVal) => {
    if (newVal) {
      selectedForecastForReceiptId.value = undefined;
    }
  }
);

const isDisabledApplyButton = computed(
  (): boolean => selectedForecastForReceiptId.value === undefined || selectedForecastForReceiptId.value === ''
);
</script>

<template>
  <InfoModal
    :modal-state="modalState"
    :back-button-label="t('キャンセル')"
    :next-button-label="t('決定')"
    :modal-width="764"
    :is-disabled-next-button="isDisabledApplyButton"
    @on-back="emits('close')"
    @on-next="emits('apply', selectedForecastForReceiptId ?? '', selectedForecastForReceiptFormState)"
  >
    <template #title>{{ t('編集する受領用内示を選択') }}</template>
    <template #description>{{ t('選択した受領用内示の取引を編集できます。') }}</template>

    <div class="edit-forecast-for-receipt-modal-content__main-content main-content">
      <div class="main-content__container">
        <div class="main-content__title">
          {{ t('受領用内示名') }}
        </div>
        <ForecastForReceiptSelectInput
          class="main-content__select-input"
          :select-input-index="selectInputIndex"
          :store-tag="'editForecastForReceipt'"
          @selected-forecast-for-receipt="(forecastForReceiptId) => (selectedForecastForReceiptId = forecastForReceiptId)"
          @selected-forecast-for-receipt-form-state="
            (forecastForReceiptFormState) => (selectedForecastForReceiptFormState = forecastForReceiptFormState)
          "
        />
      </div>
    </div>
  </InfoModal>
</template>

<style lang="scss" scoped>
.edit-forecast-for-receipt-modal-content {
  height: 100%;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 24px;
}

.main-content {
  background-color: $backgroundDefault;
  border-radius: 8px;

  &__container {
    height: 100%;
    width: 100%;
    padding: 16px;
    display: grid;
    grid-template-rows: repeat(2, auto);
    gap: 8px;
  }

  &__title {
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }

  &__select-input {
    width: 100%;
    box-sizing: border-box;
    background-color: $semanticWhite;
    border-radius: 4px;
    border: 1px solid $borderDefault;
    font-size: 14px;
    font-weight: 400;
    color: $textDefault;
  }
}
</style>
